module.exports = {
  TrueFalse: {
    PluginName: "Verdadero/Falso",
    content_box_name: "Contenido ",
    Statement:
      "Esta es una pregunta de verdadero o falso. Puedes escribir aquí el enunciado global de la pregunta",
    Question: "Pregunta",
    Answer: "Respuesta",
    Feedback: "Explicación",
    FeedbackMsg:
      "Aquí puedes incluir una explicación acerca de la respuesta. Puedes desactivar esta opción en la barra de herramientas.",
    TrueFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta correcta. Puedes desactivar esta opción en la barra de herramientas.",
    FalseFeedbackMsg:
      "Aquí puedes añadir una explicación sobre la respuesta incorrecta. Puedes desactivar esta opción en la barra de herramientas.",
    ShowFeedback: "Mostrar explicación",
    Number: "Nº de enunciados",
    QuizColor: "Color",
    notCount: "Este ejercicio no añade puntos a la nota",
    CheckAnswerText: "Texto del Botón Verificar Respuesta",
    TryAgainText: "Texto del Botón Intentar de Nuevo",
    SeeAnswerText: "Texto del Botón Ver Respuesta",
    TrueText: "Texto del Botón Verdadero",
    FalseText: "Texto del Botón Falso",
    ButtonStyle: "Estilo del Botón",
    ButtonBackground: "Color de Fondo del Botón",
    ButtonTextColor: "Color de Texto del Botón",
    ButtonBorderColor: "Color de Borde del Botón",
    ButtonBorderWidth: "Grosor del Borde del Botón",
    ButtonBorderRadius: "Radio de Borde del Botón",
    ButtonPadding: "Espaciado del Botón",
    ButtonFontSize: "Tamaño de Fuente del Botón",
    ButtonFontWeight: "Peso de Fuente del Botón",
    ButtonHoverBackground: "Color de Fondo al Pasar el Ratón",
    TrueButtonStyle: "Estilo del Botón Verdadero",
    FalseButtonStyle: "Estilo del Botón Falso",
    tryAgain: "Inténtalo de nuevo",
    checkAnswer: "Comprueba la respuesta",
    True: "Verdadero",
    False: "Falso",
  },
};
